<template>
  <div class="flex justify-center items-center container mx-auto w-full lg:max-h-screen py-10 bg-transparent">
    <div class="flex flex-col gap-5 lg:w-9/12">
      <div
        class="px-2 md:px-20"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion"
      >
        <h4>
          {{
            $t("labels.generic", { pt: "Como funciona?", en: "How it works" })
          }}
        </h4>
        <p class="mt-2">
          {{
            $t("labels.generic", {
              pt: "Conheça as principais funcionalidades que você vai ter no curso:",
              en: "Discover the main features you will have in the course:",
            })
          }}
        </p>
      </div>

      <div class="flex justify-center flex-wrap gap-10">
        <div
          class="min-w-[350px] w-[40%] min-h-[400px] border-b-4 border-h-primary-500 shadow-lg rounded-lg bg-white mt-2"
          v-for="(item, i) in cardData"
          v-motion
          :initial="initialMotion"
          :enter="enterMotion.getEnterMotion((i + 1) * 200)"
          :key="i"
        >
          <div class="flex flex-col justify-center items-center p-4">
            <img :src="item.image" :alt="item.title" class="w-[84px] mt-4" />
            <h5 class="mt-4">{{ item.title }}</h5>
            <div class="w-full p-6 pt-4">
              <ul class="list-disc" v-for="(e, i) in item.items" :key="i">
                <li class="mt-4">
                  <p v-html="e"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mb-10 px-2 md:px-20"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion(600)"
      >
        <p class="mb-5">
          {{
            $t("labels.generic", {
              pt: "Lembre-se qualquer dúvida no curso use o termo ",
              en: "To talk to him, say something like:",
            })
          }}
          <strong>“Ajuda...”</strong>.
        </p>
        <Button
          v-if="!hiddenButton"
          @click="onCloseFirstTimeCourse()"
          class="btn-primary btn-sm h-8 w-[200px]"
          :label="
            $t('labels.generic', {
              pt: 'Iniciar o curso',
              en: 'Start the course',
            })
          "
        >
        </Button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { defineComponent } from "vue";

export default defineComponent({
  name: "FirstTimeCourse",
  emits: ["onCloseFirstTimeCourse"],
  props: {
    hiddenButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
      cardData: [
        {
          image: require("@/assets/images/icons-alert/homero.svg"),
          title: this.$t("labels.generic", {
            pt: "Falar com o Homero",
            en: "Talk to Homero",
          }),
          items: [
            this.$t("labels.generic", {
              pt: "<b>Homero</b> será o seu guia no curso e poderá <b>falar por áudio</b> com você",
              en: "<b>Homero</b> will be your guide on the course and will be able to <b>speak with you via audio</b>;",
            }),
            this.$t("labels.generic", {
              pt: "Para falar com ele, fale algo como <b>“Ajuda...”, “Me ajude...” ou “Preciso de ajuda...”</b>",
              en: "To <b>talk to him</b>, start your sentence with <b>“Homero”</b> or click on the chat.",
            }),
            this.$t("labels.generic", {
              pt: "Ex: “Homero, me ajude, tenho dúvidas sobre programação” e “Homero, me ajude, tenho dúvidas sobre certificado”.",
              en: "Ex: “Homero, help me, I have questions about programming” and “Homero, me ajude, I have questions about the certificate”.",
            }),
          ],
        },
        {
          image: require("@/assets/images/icons-alert/ilust-camera.svg"),
          title: this.$t("labels.generic", {
            pt: "Detecção de atenção",
            en: "Attention detection",
          }),
          items: [
            this.$t("labels.generic", {
              pt: "<b>Para lhe ajudar a manter o foco</b>, habilite a <b>câmera</b> durante a leitura dos materiais para podermos acompanhar a sua atenção;",
              en: "<b>To help you stay focused</b>, enable the <b>camera</b> while reading materials so we can track your attention;",
            }),
            this.$t("labels.generic", {
              pt: "Lembre-se de <b>permitir o uso da câmera</b> no seu navegador para habilitar a detecção de atenção;",
              en: "Remember to <b>enable the camera</b> in your browser to enable attention detection;",
            }),
            this.$t("labels.generic", {
              pt: "Você pode desabilitar e habilitar novamente a qualquer momento na página de “Dados da Conta”.",
              en: "You can disable and enable again at any time on the “Account Details” page.",
            }),
          ],
        },
      ],
    };
  },
  methods: {
    onCloseFirstTimeCourse(): void {
      this.$emit("onCloseFirstTimeCourse");
    },
  },
});
</script>
